var map = {
	"./Epidemiologia/Peritêcio 1.webp": "3544",
	"./Epidemiologia/Peritêcio 2.webp": "61ac",
	"./Epidemiologia/ascas com ascosporos.webp": "2bbb",
	"./Epidemiologia/capa1.webp": "f67e",
	"./Epidemiologia/capa2.webp": "7fe0",
	"./Epidemiologia/conídios 1.webp": "b2d3",
	"./Epidemiologia/esporodoquio 1.webp": "58a3",
	"./Epidemiologia/esporodquio 2.webp": "2324",
	"./Etiologia/Esporodóquios e Conídios 1.webp": "6694",
	"./Etiologia/Esporodóquios e Conídios 2.webp": "d377",
	"./Etiologia/Peritécios, Ascas e Ascósporos 1.webp": "64ac",
	"./Etiologia/Peritécios, Ascas e Ascósporos 2.webp": "6d88",
	"./Etiologia/capa1.webp": "0f9c",
	"./Etiologia/capa2.webp": "70ba",
	"./Histórico/Foto 2 Mudas armazenadas em câmara fria.webp": "ad25",
	"./Histórico/capa1.webp": "88fa",
	"./Histórico/capa2.webp": "c816",
	"./Histórico/foto 1 Arranquio de mudas.webp": "5d0c",
	"./Histórico/foto 3 Incineração e mudas (1).webp": "4192",
	"./Importância/Plantas erradicadas 3.webp": "d9d3",
	"./Importância/Plantas rebaixadas e com retirada de ramos laterais 3.webp": "2bac",
	"./Importância/Plantas rebaixadas e com retirada de ramos laterais 4.webp": "642b",
	"./Importância/Plantas rebaixadas e com retirada de ramos laterais 5.webp": "8eb1",
	"./Importância/capa1.webp": "3283",
	"./Importância/capa2.webp": "b967",
	"./Instrução Normativa nº20/Planta rebaixada com novos sintomas.webp": "4d31",
	"./Instrução Normativa nº20/capa1.png": "0be9",
	"./Instrução Normativa nº20/capa2.webp": "2b32",
	"./Instrução Normativa nº20/sintoma em ponto de queda de folha 2.webp": "423c",
	"./Instrução Normativa nº20/sintoma em ponto de queda de folha.webp": "ea50",
	"./Instrução Normativa nº20/sintomas em ferimento de colheita.webp": "86ae",
	"./Sintomatologia/capa1.webp": "b0a2",
	"./Sintomatologia/capa2.webp": "f49b",
	"./Sintomatologia/sintomas estrangulamento.webp": "fa5e",
	"./Sintomatologia/sintomas podridão frutos início.webp": "0c2c",
	"./Sintomatologia/sintomas podridão frutos.webp": "6d2d",
	"./Sintomatologia/sintomas ponto colheita 2.webp": "11f5",
	"./Sintomatologia/sintomas ponto colheita.webp": "5c16",
	"./Sintomatologia/sntomas estrangulamento 2.webp": "d5cf",
	"./Situação do Cancro Europeu da Macieira em Santa Catarina/Falhas nas linhas de plantio devido erradição de plantas 1.webp": "1cf9",
	"./Situação do Cancro Europeu da Macieira em Santa Catarina/Falhas nas linhas de plantio devido erradição de plantas 2.webp": "50d1",
	"./Situação do Cancro Europeu da Macieira em Santa Catarina/Queima de ramos podados.webp": "88d7",
	"./Situação do Cancro Europeu da Macieira em Santa Catarina/Retirada de ramos podados do pomar.webp": "5f5a",
	"./Situação do Cancro Europeu da Macieira em Santa Catarina/capa1.png": "b61f",
	"./Situação do Cancro Europeu da Macieira em Santa Catarina/capa2.webp": "f91c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de39";